import React, {FunctionComponent} from 'react';

interface ValidationWarningTextProps {
    text: string
}

export const ValidationWarningText: FunctionComponent<ValidationWarningTextProps> = (props) => {
    return (
        <span className='validation-warning-text'>{props.text}</span>
    );
}